var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.046 18.05.761-12.36H16.26l.857 12.36H3.046zm7.028-16.244c1.616 0 3.105 1.314 3.295 2.93l-6.52.004c.19-1.617 1.608-2.934 3.225-2.934zm7.137 3.314c0-.19-.103-.395-.475-.38h-2.377c-.284-2.377-2.377-3.993-4.753-3.707A4.066 4.066 0 0 0 5.898 4.74H3.426c-.342.011-.44.168-.475.38L2 18.43c0 .095 0 .285.095.38.096.095.19.19.38.19h15.211c.096 0 .286-.095.382-.19.094-.095.094-.285.094-.38l-.95-13.31z",
    fill: "black",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.f56ebd27735083210960b396cfb94ab7.svg";
export { ForwardRef as ReactComponent };